import mixins from 'synergycms_core/src/less/mixins';

export default {
  wrapperContent: {},
  itemBox: {},
  wrapperMultiContent: {},
  shadowColor:{},
  defaultShadowColor:{},
  rightShadow:{
    '&$shadowColor':{
      '&:before':{
        content:"''",
        position:'absolute',
        left:0,
        right:0,
        top:0,
        bottom:0,
        pointerEvents:'none',
        zIndex:1,
        //boxShadow:'inset -34px 0px 20px -12px #00111b'
      }
    },
    '&$defaultShadowColor':{
      '&:before':{
        content:"''",
        position:'absolute',
        left:0,
        right:0,
        top:0,
        bottom:0,
        pointerEvents:'none',
        zIndex:1,
        //boxShadow:data => 'inset -34px 0px 20px -12px ' + data.backgroundEngine
      }
    }
  },
  leftShadow:{
    '&$shadowColor':{
      '&:after':{
        content:"''",
        position:'absolute',
        left:0,
        right:0,
        top:0,
        bottom:0,
        pointerEvents:'none',
        zIndex:1,
        //boxShadow:'inset 34px 0px 20px -12px #00111b'
      }
    },
    '&$defaultShadowColor':{
      '&:after':{
        content:"''",
        position:'absolute',
        left:0,
        right:0,
        top:0,
        bottom:0,
        pointerEvents:'none',
        zIndex:1,
        //boxShadow:data => 'inset 34px 0px 20px -12px ' + data.backgroundEngine
      }
    }
  },
  noShadow:{
    '&:after':{
      content:"none",
    }
  },
  nestedMultiContent: {},
  defaultStyle: {
    width: '100%',
    height: '100%',
    position: 'relative',
    '& $wrapperContent': {
      maxWidth: '1365px',
      margin: '0 auto',
      overflow: 'hidden',
      height: '100%',
      width: '100%',
      padding: '20px',
      ...mixins.boxSizing(),
      '& > div': {
        position: 'relative',
        height: '300px',
        '@media (min-width: 801px)': {
          height: '550px'
        },
      },
      '& $itemBox': {
        position: 'absolute',
        overflow: 'hidden',
        top: '0',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex:'500',
        '& > div': {
          position: 'absolute',
          top: '0',
          bottom: '0',
          left: '0',
          width: '100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          '&:lang(ar)': {
            left: 'auto',
            right: 0
          },
          '@media (min-width: 801px)': {
            backgroundPosition: 'center top',
            backgroundSize: 'contain'
          },
        },
        '&:lang(ar)': {
          left: 'auto',
          right: 0
        }
      },
    },
    '& $wrapperMultiContent': {
      margin: '0',
      padding: '0',
      paddingLeft: '4px',
      '& $nestedMultiContent': {
        display: 'flex',
        alignItems:'flex-end',
        gap: '15px',
        flexWrap:'nowrap',
        paddingTop:'10px',
        width:'100%!important',
        '&$nestedPortalSlide':{
          padding:'0',
          alignItems:'flex-end'
        }
      },
      '@media (max-width: 800px)': {
        overflowY:'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth:'none',
        '&::-webkit-scrollbar':{
          display:'none'
        }
      },
    },
    '@media (min-width: 801px)': {
      //overflowY:'scroll',
      msOverflowStyle: 'none',
      scrollbarWidth:'none',
      '&::-webkit-scrollbar':{
        display:'none'
      }
    },
  },
  slideButton:{
    position:'absolute',
    top:'50%',
    marginTop:'-16px',
    height:'30px',
    width:'30px',
    zIndex:'1',
    '& span': {
      //color: '#fff',
      color: data => data.mainColor,
      borderBottomColor: 'rgba(255, 255, 255, 0.6)',
      fontSize: '16px',
      lineHeight:'1px'
    },
  },
  nextButton:{
    right:0,
  },
  prevButton: {
    left:0
  },
  contentBlock: {
    position: 'relative'
  },
  backgroundEnterActive: {},
  backgroundEnterActivePrev: {},
  backgroundEnter: {
    transform: 'translate(100%)',
    '&$backgroundEnterActive': {
      transform: 'translate(0%)',
      transition: 'transform 300ms ease-in-out'
    }
  },
  backgroundEnterPrev: {
    transform: 'translate(-100%)',
    '&$backgroundEnterActivePrev': {
      transform: 'translate(0%)',
      transition: 'transform 300ms ease-in-out'
    }
  },
  backgroundLeaveActive: {},
  backgroundLeaveActivePrev: {},
  backgroundLeave: {
    transform: 'translate(0%)',
    '&$backgroundLeaveActive': {
      transform: 'translate(-100%)',
      transition: 'transform 300ms ease-in-out'
    }
  },
  backgroundLeavePrev: {
    transform: 'translate(0%)',
    '&$backgroundLeaveActivePrev': {
      transform: 'translate(100%)',
      transition: 'transform 300ms ease-in-out'
    }
  },
  nestedPortalSlide:{}
};
